/**
 * `payout` translations -- the resignation leave payout preview,
 * `pages/hr/ResignationPayoutPanel.tsx`.
 */
export const resignationPayout = {
  mn: {
    payout: {
      title: 'Ажлаас гарах үеийн чөлөөний тооцоо',
      intro: 'Урьдчилсан тооцоо — юу ч хадгалагдахгүй, төлөгдөхгүй.',
      resignDate: 'Ажлаас гарах огноо',
      sourceStored: 'Бүртгэлтэй огноо',
      sourceQuery: 'Сонгосон огноо',
      sourceToday: 'Ажлаас гарах огноо бүртгэгдээгүй — өнөөдрөөр тооцов',
      yearElapsed: 'Жилийн өнгөрсөн хэсэг',
      workDaysOf: '{{worked}} / {{total}} ажлын өдөр',
      dayValue: 'CL/PSL нэг өдрийн үнэ',
      alDayValue: 'ЭА нэг өдрийн үнэ',
      notFullTime: 'Бүтэн цагийн ажилтан биш — ээлжийн амралтын үнэ 0.',
      cl: 'Энгийн чөлөө (CL)',
      psl: 'Цалинтай өвчний чөлөө (PSL) — зөвхөн мэдээлэл, төлөгдөхгүй',
      al: 'Ээлжийн амралт (AL)',
      listBalance: 'Жагсаалтын үлдэгдэл',
      future: '+ Ирээдүйн (аваагүй, буцаан нэмсэн)',
      adjusted: '= Тохируулсан үлдэгдэл',
      used: 'Энэ жил ашигласан',
      collected: 'Одоог хүртэл хуримтлагдсан (3-аас)',
      bonus: 'Урамшууллын сан (эрх − 3)',
      payoutDays: 'Төлөх өдөр',
      allocation: 'Жилийн эрх',
      earned: 'Одоог хүртэл олсон',
      unearned: 'Олоогүй хэсэг',
      net: 'Цэвэр (тохируулсан − олоогүй)',
      deductDays: 'Суутгах өдөр',
      amount: 'Дүн',
      total: 'Нийт тооцоо',
      add: 'Цалинд нэмнэ',
      deduct: 'Цалингаас суутгана',
      unknown: 'Тооцоолох боломжгүй',
      records: 'Тооцоонд орсон чөлөө (энэ жил)',
      futureRecord: 'Ирээдүйн — буцаан нэмсэн',
      usedRecord: 'Ашигласан',
      none: 'Байхгүй',
      loadFailed: 'Тооцоог ачаалж чадсангүй',
      reasonNoGrossHistory: 'Сүүлийн 12 сарын олгосон цалингийн түүх алга — ЭА өдрийн үнийг тооцох боломжгүй.',
      reasonAllocationUnknown: 'Ээлжийн амралтын эрх (AL type) бүртгэгдээгүй — олоогүй хэсгийг тооцох боломжгүй.',
      reasonNoRate: 'Ажлаас гарах өдөр хүчинтэй цалингийн хэмжээ алга.',
      reasonNoLeaveInfo: 'Чөлөөний үлдэгдлийн бүртгэл алга.',
      reasonOther: 'Тооцоонд шаардлагатай мэдээлэл дутуу.',
      closeoutTitle: 'Хааж олгох',
      alSettled: 'AL аль хэдийн тооцогдсон',
      breakTitle: 'Жирэмсний амралтын олговор',
      breakStart: 'Амралт эхэлсэн',
      breakClPsl: 'CL ба PSL',
      breakStatus: 'Төлөв',
      breakPaid: 'Олгосон',
      breakPending: 'Сарын эцсийн цалинд олгогдоно',
      closeoutStatusClosed: 'Хаагдсан — эцсийн цалинд нэмэгдэнэ',
      closeoutStatusPaid: 'Олгосон',
      closeOut: 'Хааж олгох',
      markPaid: 'Олгосон гэж тэмдэглэх',
      voidCloseout: 'Хаалтыг цуцлах',
      voidCloseoutConfirm: 'Энэ хаалтыг цуцлах уу?',
      closeoutHint: 'Тооцоо боломжтой, бүртгэлтэй огноотой үед л хаана.',
      closeoutFailed: 'Үйлдэл амжилтгүй',
      paidOffTitle: 'Чөлөөг аль хэдийн олгосон',
      paidOffIntro: 'AL, CL, PSL-ийг сонгосон огнооноос тэглэнэ. Хуучин үлдэгдэл түүхэнд хадгалагдана.',
      paidOffAsOf: 'Олгосон огноо',
      paidOffReason: 'Шалтгаан',
      paidOffSubmit: 'Олгосон гэж тэглэх',
      paidOffConfirm: 'Энэ хүний AL, CL, PSL-ийг тэглэх үү?',
      paidOffDone: 'Чөлөөний үлдэгдлийг тэглэлээ',
      paidOffNothing: 'Тэглэх үлдэгдэл байсангүй',
      paidOffNeedReason: 'Шалтгаанаа бичнэ үү',
      paidOffFuture: 'Огноо ирээдүйд байж болохгүй',
      paidOffVia: 'Нэг удаагийн төлбөрийг',
      paidOffViaByHand: 'Гараар олгосон',
      paidOffViaWebApp: 'Вэб аппаар олгосон',
      paidOffNeedVia: 'Гараар эсвэл вэб аппаар олгосныг сонгоно уу',
    },
  },
  en: {
    payout: {
      title: 'Resignation leave payout',
      intro: 'A preview — nothing is saved or paid from here.',
      resignDate: 'Resignation date',
      sourceStored: 'Recorded resignation date',
      sourceQuery: 'Date chosen here',
      sourceToday: 'No resignation date recorded — computed as of today',
      yearElapsed: 'Year elapsed',
      workDaysOf: '{{worked}} / {{total}} work days',
      dayValue: 'CL/PSL day value',
      alDayValue: 'AL day value',
      notFullTime: 'Not Full Time — no annual-leave value.',
      cl: 'Casual leave (CL)',
      psl: 'Paid sick leave (PSL) — information only, never paid',
      al: 'Annual leave (AL)',
      listBalance: 'List balance',
      future: '+ Future (not taken, added back)',
      adjusted: '= Adjusted balance',
      used: 'Used this year',
      collected: 'Collected to date (of 3)',
      bonus: 'Bonus pool (allocation − 3)',
      payoutDays: 'Payout days',
      allocation: 'Allocation',
      earned: 'Earned to date',
      unearned: 'Unearned',
      net: 'Net (adjusted − unearned)',
      deductDays: 'Deduct days',
      amount: 'Amount',
      total: 'Total settlement',
      add: 'Adds to final pay',
      deduct: 'Deducts from final pay',
      unknown: 'Cannot be computed',
      records: 'Leave records included (this year)',
      futureRecord: 'Future — added back',
      usedRecord: 'Used',
      none: 'None',
      loadFailed: 'Could not load the payout preview',
      reasonNoGrossHistory: 'No issued salary history in the 12 months before — the AL day value cannot be computed.',
      reasonAllocationUnknown: 'No annual-leave allocation (AL type) on record — the unearned part cannot be computed.',
      reasonNoRate: 'No pay rate in force on the resignation date.',
      reasonNoLeaveInfo: 'No leave balance record.',
      reasonOther: 'An input the calculation needs is missing.',
      closeoutTitle: 'Close out and pay',
      alSettled: 'AL already settled',
      breakTitle: 'Maternity payout',
      breakStart: 'Break start',
      breakClPsl: 'CL and PSL',
      breakStatus: 'Status',
      breakPaid: 'Paid',
      breakPending: 'Rides on the next final run',
      closeoutStatusClosed: 'Closed out — rides on the final run',
      closeoutStatusPaid: 'Paid',
      closeOut: 'Close out and pay',
      markPaid: 'Mark as paid',
      voidCloseout: 'Void the close-out',
      voidCloseoutConfirm: 'Void this close-out?',
      closeoutHint: 'Available only when the figure can be computed for the recorded date.',
      closeoutFailed: 'The action failed',
      paidOffTitle: 'Leave already paid off',
      paidOffIntro: 'Zeroes AL, CL and PSL as of the chosen date. The old balances stay in the history.',
      paidOffAsOf: 'Paid off on',
      paidOffReason: 'Reason',
      paidOffSubmit: 'Zero as paid off',
      paidOffConfirm: "Zero this person's AL, CL and PSL?",
      paidOffDone: 'Leave balances zeroed',
      paidOffNothing: 'There was nothing to zero',
      paidOffNeedReason: 'Say why',
      paidOffFuture: 'The date cannot be in the future',
      paidOffVia: 'The one-off was paid',
      paidOffViaByHand: 'By hand',
      paidOffViaWebApp: 'On the web app',
      paidOffNeedVia: 'Choose whether it was paid by hand or on the web app',
    },
  },
  ru: {
    payout: {
      title: 'Расчёт отпуска при увольнении',
      intro: 'Предварительный расчёт — здесь ничего не сохраняется и не выплачивается.',
      resignDate: 'Дата увольнения',
      sourceStored: 'Записанная дата увольнения',
      sourceQuery: 'Выбранная дата',
      sourceToday: 'Дата увольнения не записана — расчёт на сегодня',
      yearElapsed: 'Прошедшая часть года',
      workDaysOf: '{{worked}} / {{total}} рабочих дней',
      dayValue: 'Стоимость дня CL/PSL',
      alDayValue: 'Стоимость дня отпуска',
      notFullTime: 'Не полная занятость — стоимость отпуска 0.',
      cl: 'Отгулы (CL)',
      psl: 'Оплачиваемый больничный (PSL) — только для сведения, не выплачивается',
      al: 'Ежегодный отпуск (AL)',
      listBalance: 'Остаток по списку',
      future: '+ Будущие (не взяты, возвращены)',
      adjusted: '= Скорректированный остаток',
      used: 'Использовано в этом году',
      collected: 'Накоплено на дату (из 3)',
      bonus: 'Бонусный пул (норма − 3)',
      payoutDays: 'Дни к выплате',
      allocation: 'Годовая норма',
      earned: 'Заработано на дату',
      unearned: 'Не заработано',
      net: 'Итого (скорр. − не заработано)',
      deductDays: 'Дни к удержанию',
      amount: 'Сумма',
      total: 'Итоговый расчёт',
      add: 'Добавляется к окончательной выплате',
      deduct: 'Удерживается из окончательной выплаты',
      unknown: 'Невозможно рассчитать',
      records: 'Учтённые отпуска (этот год)',
      futureRecord: 'Будущий — возвращён',
      usedRecord: 'Использован',
      none: 'Нет',
      loadFailed: 'Не удалось загрузить расчёт',
      reasonNoGrossHistory: 'Нет выданных зарплат за 12 месяцев — стоимость дня отпуска не рассчитать.',
      reasonAllocationUnknown: 'Не указана годовая норма отпуска (AL type) — незаработанную часть не рассчитать.',
      reasonNoRate: 'Нет ставки, действующей на дату увольнения.',
      reasonNoLeaveInfo: 'Нет записи об остатках отпуска.',
      reasonOther: 'Не хватает данных для расчёта.',
      closeoutTitle: 'Закрыть и выплатить',
      alSettled: 'AL уже рассчитан',
      breakTitle: 'Выплата при декретном отпуске',
      breakStart: 'Начало отпуска',
      breakClPsl: 'CL и PSL',
      breakStatus: 'Статус',
      breakPaid: 'Выплачено',
      breakPending: 'Будет выплачено в ближайшем итоговом расчёте',
      closeoutStatusClosed: 'Закрыто — войдёт в итоговую выплату',
      closeoutStatusPaid: 'Выплачено',
      closeOut: 'Закрыть и выплатить',
      markPaid: 'Отметить выплаченным',
      voidCloseout: 'Отменить закрытие',
      voidCloseoutConfirm: 'Отменить это закрытие?',
      closeoutHint: 'Доступно, только если расчёт возможен на записанную дату.',
      closeoutFailed: 'Не удалось выполнить действие',
      paidOffTitle: 'Отпуск уже выплачен',
      paidOffIntro: 'Обнуляет AL, CL и PSL на выбранную дату. Прежние остатки остаются в истории.',
      paidOffAsOf: 'Дата выплаты',
      paidOffReason: 'Причина',
      paidOffSubmit: 'Обнулить как выплаченное',
      paidOffConfirm: 'Обнулить AL, CL и PSL этого сотрудника?',
      paidOffDone: 'Остатки отпуска обнулены',
      paidOffNothing: 'Обнулять было нечего',
      paidOffNeedReason: 'Укажите причину',
      paidOffFuture: 'Дата не может быть в будущем',
      paidOffVia: 'Разовая выплата произведена',
      paidOffViaByHand: 'Вручную',
      paidOffViaWebApp: 'В веб-приложении',
      paidOffNeedVia: 'Выберите: выплачено вручную или в веб-приложении',
    },
  },
}
